import React, { useEffect, useState, useRef } from 'react';
import { VehicleDataModel, Riders_PackagesModel, RiderPackageModel } from '../../models/superbit-api-models'
import { SubscribersModel } from '../../models/SubscribersModel'
import { IDNameDescriptionItem, IDNameDescriptionDictionary, filterIDNameDescriptionDictionary, AutocompleteData } from '../../models/Site'
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect'


type Props = {
    riderId: string | undefined;
    riderPackages?: Riders_PackagesModel[] | undefined;
    vehicle: VehicleDataModel | undefined;
    packages: RiderPackageModel[] | undefined;
    startDate?: Date;
    endDate?: Date;
    updatePackages: Function;
    doValidate:boolean;
};


class RiderPackagesWithErrors {
    package: Riders_PackagesModel;
    showDescription: boolean;
    errors: {
        customerCostErrorMsg?: string;

    };


    constructor(p: Riders_PackagesModel) {

        this.package = p;
        this.errors = {};
        this.showDescription = false;
    }
}


const RiderPackages = (props: Props) => {
    const emptyGuid = "00000000-0000-0000-0000-000000000000";

    const [vehicleId, setVehicleId] = useState<string | undefined>(undefined);
    const [packagesList, setPackagesList] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [packagesListAll, setPackagesListAll] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [packagesListAll2, setPackagesListAll2] = useState<RiderPackageModel[]>([]);
    const [riderPackages, setRiderPackages] = useState<RiderPackagesWithErrors[]>([]);
    const [packagesErrMsg, setPackagesErrMsg] = useState<string>("");
    const [loading, setloading] = useState<boolean>(false);
    const [packagesListIds, setPackagesListIds] = useState<any[]>([]);


    useEffect(() => {
        init();

    }, [])

    useEffect(() => {
        packagesValidation();
    }, [props.doValidate])

    useEffect(() => {
        calcPrices();

    }, [props.startDate, props.endDate])

    useEffect(() => {
// 
        props.updatePackages(riderPackages);
        packagesValidation();
    }, [riderPackages])

    const calcPrices = () => {

        if (props.startDate && props.endDate) {
            if (riderPackages) {

                for (var i = 0; i < riderPackages.length; i++) {
                    riderPackages[i] = new RiderPackagesWithErrors(calculatePackegePrice(riderPackages[i].package));
                }
            }
        }
    }

    const init = async () => {
        //add loading
        setloading(true);
        var packagesIds = await new SubscribersModel().riderGetPackages(props.vehicle);
        await setPackagesListAll2(JSON.parse(JSON.stringify(props.packages)));
        await setPackagesListAll(buildPackagesList(props.packages));

        setPackagesListIds(packagesIds);



        if (props.packages) {


            //setRiderPackages(filteredData2.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) );
            if (props.riderPackages) {
                let existingPackagesIds = props.riderPackages.map((x: Riders_PackagesModel) => x.riderPackageId);


                var filteredData = props.packages.filter((item) =>
                    item.id && packagesIds.includes(item.id) 
                && !existingPackagesIds.includes(item.id)
            );


                await setPackagesList(buildPackagesList(filteredData));

                await setRiderPackages(props.riderPackages.map((x: Riders_PackagesModel) => { return new RiderPackagesWithErrors(x); }));
            }
        }

        
        setloading(false);
    };


    const buildPackagesList = (packages: any) => {
        const newList: any = [{
            description: 'בחר',
            name: 'בחר',
            id: 0,
            package: null
        }
        ];
        packages.forEach((p: any) => {
            newList.push({
                description: p.name,
                name: p.name,
                id: p.id
            })
        });
        console.log('buildPackagesList', newList)
        return newList as IDNameDescriptionDictionary;
    }

    const roundDownNearest10 = (num: number) => {
        return Math.floor(num / 10) * 10;
    }

    const addRiderPackage = (selectedPackage: any) => {
        if (!riderPackages) {
            setRiderPackages([]);
        }
        let _riderPackages = riderPackages;

        const newRiderPackage = new Riders_PackagesModel();
        newRiderPackage.riderId = props.riderId;
        newRiderPackage.riderPackageId = selectedPackage.id;
        newRiderPackage.riderPackage = selectedPackage;
        newRiderPackage.agentCost = selectedPackage.agentCost;
        newRiderPackage.customerCost = selectedPackage.recommendedCost;

        setRiderPackages([...riderPackages, new RiderPackagesWithErrors(newRiderPackage)]);

        // _riderPackages.push(new RiderPackagesWithErrors(newRiderPackage));
        // setRiderPackages(_riderPackages);
    }

    const handleChangeriderPackageCustomerCost = async (packageId: string, e: any) => {

        var err = "";
                            console.log('packagesValidation- riderPackages', riderPackages)

        if (riderPackages && riderPackages.length > 0) {

            const selectedIndex = riderPackages.findIndex((p: any) => p.package.riderPackageId === packageId);

            if (selectedIndex != undefined) {
                var cost = parseInt(e.target.value);
                // if (cost < 150) {
                //     err = "מחיר נמוך מ150 שח";
                // }
                console.log('packagesValidation - cost', cost)

                if (riderPackages[selectedIndex] && riderPackages[selectedIndex].package) {
                    let agentCost = riderPackages[selectedIndex].package?.riderPackage?.agentCost as number;
                    console.log('packagesValidation - agentCost', agentCost)
                    let calculatedAgentCost = calculatePackegePriceForAgent(agentCost);
                    if (agentCost && calculatedAgentCost > cost) {
                        err = "מחיר נמוך מעלות לסוכן";
                    }
                }


                riderPackages[selectedIndex].package.customerCost = e.target.value;

                if(err == "") {
                    riderPackages[selectedIndex].errors = {};
                }else{
                    riderPackages[selectedIndex].errors.customerCostErrorMsg = err;
                }
                console.log('packagesValidation - riderPackages', riderPackages)
                //setRiderPackages(riderPackages);
                setRiderPackages([...riderPackages]);
            }



        }

    }

    const calculatePackegePrice = (_package: Riders_PackagesModel) => {

        if (props.startDate && props.endDate) {
            var days = calculateDaysBetweenDates(props.startDate, props.endDate) + 1;
            const selectedPackage = packagesListAll2.find((p: any) => p.id === _package.riderPackageId);
            if (selectedPackage) {
                // Create a deep copy of both selectedPackage and _package
                const selectedPackageCopy = JSON.parse(JSON.stringify(selectedPackage));

                var RecommendedCost = JSON.parse(JSON.stringify(selectedPackageCopy.recommendedCost as number));
                if (RecommendedCost) {
                    if (days != 365) {
                        RecommendedCost = roundDownNearest10(RecommendedCost / 365 * days);
                    }
                    _package.customerCost = RecommendedCost;

                }

                // var agentCost = JSON.parse(JSON.stringify(selectedPackageCopy.agentCost as number));
                // if (agentCost) {
                //     if (days != 365) {
                //         agentCost = roundDownNearest10(agentCost / 365 * days);
                //     }
                //     _package.agentCost = agentCost;
                // }
            }


        }
        return _package;
    }

    const calculatePackegePriceForAgent = (agentPrice: number) => {

        if (props.startDate && props.endDate) {
            var days = calculateDaysBetweenDates(props.startDate, props.endDate) + 1;
            var RecommendedCost = agentPrice;
            if (RecommendedCost) {
                if (days != 365) {
                    RecommendedCost = roundDownNearest10(RecommendedCost / 365 * days);
                }
                return RecommendedCost;

            }
        }
        return agentPrice;

    }

    const calculatePackegePrice2 = (_package: RiderPackageModel) => {
        if (props.startDate && props.endDate) {
            var days = calculateDaysBetweenDates(props.startDate, props.endDate) + 1;
            const selectedPackage = packagesListAll2.find((p: any) => p.id === _package.id);

            if (selectedPackage) {
                // Create a deep copy of both selectedPackage and _package
                const selectedPackageCopy = JSON.parse(JSON.stringify(selectedPackage));
                var RecommendedCost = JSON.parse(JSON.stringify(selectedPackageCopy.recommendedCost as number));
                if (RecommendedCost) {
                    if (days != 365) {
                        RecommendedCost = roundDownNearest10(RecommendedCost / 365 * days);

                    }
                    _package.recommendedCost = RecommendedCost;
                }
            }
        }
        return _package;
    }

    const calculateDaysBetweenDates = (date1: Date, date2: Date): number => {
        return Math.round((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));


    };

    const removeRiderPackage = (packageId: string) => {

        console.log('packageId to remove:', packageId);
        if (riderPackages) {

            // const selectedPackage = riderPackages.find((p: any) => p.package.riderPackage.id === packageId);
            // if (selectedPackage && selectedPackage.package.riderPackage && selectedPackage.package.riderPackage.id) {
            //     setPackagesList({
            //         ...packagesList,
            //         [selectedPackage.package.riderPackage.id]: {
            //             description: selectedPackage.package && selectedPackage.package.riderPackage ? selectedPackage.package.riderPackage.name : "",
            //             name: selectedPackage.package && selectedPackage.package.riderPackage ? selectedPackage.package.riderPackage.name : "",
            //             id: selectedPackage.package && selectedPackage.package.riderPackage ? selectedPackage.package.riderPackage.id : ""
            //         }
            //     });

            // }


            const selectedPackageIndex = riderPackages.findIndex((p: any) => p.package.riderPackage.id === packageId);
            if (selectedPackageIndex >= 0) {
                // console.log('package to remove:', selectedPackage);
                riderPackages.splice(selectedPackageIndex, 1);                
                setRiderPackages([...riderPackages]);


                let existingPackagesIds = riderPackages.map((x: any) => x.riderPackageId);


                if (props.packages) {

                    var filteredData = props.packages.filter((item) =>
                        item.id && packagesListIds.includes(item.id) 
                    && !existingPackagesIds.includes(item.id)
                );
    
    
                    setPackagesList(buildPackagesList(filteredData));

                }

            }

        }
    }

    const toggleInfo = async (packageId: string) => {
        if (riderPackages) {
            const selectedPackage = riderPackages.find((p: any) => p && p.package.riderPackageId === packageId);
            if (selectedPackage) {
                selectedPackage.showDescription = !selectedPackage.showDescription;
                setRiderPackages(riderPackages);
            }

        }
    }

    const onSelectPackage = (name: string, value: any) => {
        console.log(name, value);

        const selectedPackage = packagesListAll2.find((p: any) => p.id === value);

        if (selectedPackage) {
            console.log('selectedPackage', selectedPackage);
            //calc prices


            addRiderPackage(calculatePackegePrice2(selectedPackage));


            var filteredData = filterIDNameDescriptionDictionary(packagesList, (item) =>
                item.id !== value);

            setPackagesList(filteredData);

        }

    }

    const isAdmin = () =>{
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0 || loggedUser.role == 8;
        }
        return false;
    }

    const packagesValidation = () => {
// 
        var valid = true;
        var packages = riderPackages;
        if (packages && packages.length > 0) {

            packages.forEach((p: RiderPackagesWithErrors) => {
                if (p.errors.customerCostErrorMsg && p.errors.customerCostErrorMsg.length > 0) {
                    // 
                    if(!isAdmin()){
                        valid = false;
                    }
                    
                }
                if (p.package.activityStatus == 1) {
                    setPackagesErrMsg("חובה לבטל את כל החבילות הבעיתיות");
                    valid = false;
                }
            });
            

        }
        else {
            valid = false;
            setPackagesErrMsg("חובה לבחור לפחות חבילה אחת");
        }
        if(valid)
            setPackagesErrMsg("");
        return valid;
    }

    return (
        <div>
            <div>
                <img src={require("../../assets/images/loading-gif.gif")} className={loading ? "loadingGif" : "hide"} />
            </div>
            <div>
                <div className="tab-content-title">
                    חבילות
                </div>
                <div className="content-table">
                    <div className="table-header">
                        <div className="table-row">
                            <div className="cell">
                                חבילה
                            </div>
                            <div className="cell">
                                מחיר
                            </div>
                            <div className="cell empty">

                            </div>
                            <div className="cell actions">
                                פעולות
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {riderPackages != null ? riderPackages.map((item: any, index: number) => {
                            return (
                                <div className={item.package.activityStatus == 1 ? "table-row centered-line " : "table-row"}   >
                                    {item.package.activityStatus == 1 ? <div className='centered-line-div' ></div> : ""}
                                    <div className="cell">
                                        {item.package.riderPackage.name}
                                    </div>
                                    <div className="cell">
                                        <input type="number" value={
                                            item.package.customerCost}
                                            onChange={(e: any) => handleChangeriderPackageCustomerCost(item.package.riderPackageId, e)}
                                            disabled={!isAdmin()}
                                        /> ₪
                                        <div className='error-message2'>{item.errors.customerCostErrorMsg}</div>
                                    </div>
                                    <div className="cell empty">

                                    </div>
                                    <div className="cell actions">
                                        <div className="icon document-icon" onClick={(e: any) => toggleInfo(item.package.riderPackageId)} /*onMouseOut={(e: any) => this.toggleInfo(item.package.riderPackageId)}*/></div>
                                        <div className={item.showDescription ? "commentStyle" : "hide"} dangerouslySetInnerHTML={{ __html: item.package.riderPackage.comment }}></div>
                                        <div className="icon delete-icon pointer click-for-remove" onClick={(e: any) => removeRiderPackage(item.package.riderPackageId)}></div>
                                    </div>
                                </div>

                            )
                        }) : ""}

                    </div>

                </div>
                <div className="parameter-row">
                    <div className="parameter-item wide-item">
                        <div className="field">
                            <div className="title">
                                חבילה
                            </div>
                            <div className="value">
                                {/* <input type="text" />
                                                <div className="icon small-icon select-arrow pointer"></div> */}
                                {packagesList ? (
                                    <IDNameDescriptionItemSelect
                                        OnChange={(n: string, v: string) => onSelectPackage(n, v)}
                                        Id={"package"} Options={packagesList}
                                        Value={''}
                                    />
                                ) : ""}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className='error-message2'>{packagesErrMsg}</div>
            <div className={(riderPackages != null && riderPackages.length > 1) ? "error-message2" : "hide"} >אנא וודא שלא רכשת כיסויים כפולים</div>
        </div>



    );
};

//export default forwardRef<ChildRef, Props>(VehicleData);
export default RiderPackages;
